import { Image, View } from '@react-pdf/renderer';
import { SmallHeading } from 'PDF/components/SmallHeading';

type ExamplePageWithGenerateImagesPdfProps = {
  imageSrc: string;
  itemsNumber: number;
  heading?: string;
};

export const VerticalTimelineImagePdf = (
  { imageSrc, itemsNumber, heading }: ExamplePageWithGenerateImagesPdfProps
) => itemsNumber === 0 || !imageSrc ? null : (
  <View style={{ marginBottom: 30 }} wrap={false}>
    {heading && <SmallHeading heading={heading} />}
    <View style={{ width: '100%' }}>
      {imageSrc && (
        <Image
          src={imageSrc}
          style={{ width: '100%' }}
        />
      )}
    </View>
  </View>
);
